import { mapState } from "vuex";

export default {
	props: { device: Object },

	data: () => ({
		defaultConfig: {},
	}),

	computed: {
		...mapState("wizard", ["done", "index"]),
	},

	async created() {
		await this.build(this.device);
	},

	watch: {
		async done(val) {
			if (val) {
				await this.$store.dispatch("wizard/reset");
				this.$emit("close");
			}
		},
	},

	methods: {
		async stop() {
			// Send stop to current step, if supported
			const [step] = this.$refs.stepper.$refs[`component-${this.index}`];
			if (step && typeof step === "function") {
				await step.stop();
			}
		},

		async build(device) {
			let type = this.type;
			let defaultConfig = this.defaultConfig;
			await this.$store.dispatch("wizard/load", {
				device,
				type,
				defaultConfig,
			});
		},
	},
};
